export const ORDER_LIST = "ORDER_LIST";
export const SELECTED_ORDER = "SELECTED_ORDER";